// /youtube-feature
import React from 'react';
import ProductPage from './ProductPage';
import youtube_header from '../../assets/images/unauth/youtube-feature-header.jpg';
import youtube_poster from '../../assets/images/unauth/youtube-feature-poster.jpg';
import youtube_timestamps from '../../assets/images/unauth/youtube-feature-timestamps.jpg';
import youtube_chat from '../../assets/images/unauth/youtube-feature-chat.jpg';

const YouTubeFeature = () => (
  <ProductPage
    path="/youtube-feature"
    seo={{
      title: 'AI Analyze Your YouTube Video | Bumpups.com',
      description: 'Streamline your YouTube workflow with Bumpups. Paste a link to any public video to get AI timestamps, then chat with it for summaries and actionable insights.',
    }}
    hero={{
      title: 'Any YouTube video',
      subtitle: 'Bumpups streamlines your workflow by processing public YouTube videos, including past livestreams.',
      image: youtube_header,
      imageAlt: 'A YouTube link pasted into Bumpups, showing the video, its length, and a Start button',
      width: 1400,
      height: 864,
    }}
    marquee
    workflow={{
      title: 'Your YouTube workflow',
      description: 'Handle YouTube videos with ease, whether it’s a fresh upload, an older favorite, or a finished livestream.',
      video: '/media/youtube-feature.mp4',
      poster: youtube_poster,
      features: [
        { title: 'Upload & process videos', text: 'Paste the link to any public YouTube video and Bumpups processes it for you.' },
        { title: 'Integrated YouTube insights', text: 'Get AI timestamps automatically, then chat with the video for summaries, notes, quotes, and more.' },
        { title: 'Video specifications', text: 'Videos up to 3 hours long, at resolutions from 480p to 4K.' },
      ],
    }}
    rows={[
      {
        title: 'Timestamps for every video',
        text: 'Bump AI chapters every YouTube video you add, with specific titles for each moment that you can copy straight into your description.',
        cta: 'Try it out',
        image: youtube_timestamps,
        alt: 'A TED talk in Bumpups with its AI-generated timestamps',
      },
      {
        title: 'Ask Bump AI anything',
        text: 'Bump AI can generate tables, bullet points, checklists, email drafts, summaries, scripts, lecture notes, quiz questions, SWOT analyses, and more about your YouTube video, and it remembers the conversation so you can follow up.',
        cta: 'Try it out',
        image: youtube_chat,
        alt: 'Bump AI turning its answer about a Harvard lecture into three exam questions',
      },
    ]}
  />
);

export default YouTubeFeature;
